/* eslint-disable */
import React, { useMemo } from 'react';
import AttackerTargetGrid from '../../components/AttackerTargetGrid';
import WhySmeTargetContent from '../../components/WhySmeTargetContent';
import TargetBg from '../../../../../../assets/sme/ics/target_bg.png';
import CardBg1 from '../../../../../../assets/sme/ics/attacker/card_bg_1.png';
import CardBg2 from '../../../../../../assets/sme/ics/attacker/card_bg_2.png';
import CardBg3 from '../../../../../../assets/sme/ics/attacker/card_bg_3.png';
import CardBg4 from '../../../../../../assets/sme/ics/attacker/card_bg_4.png';
import CardBg5 from '../../../../../../assets/sme/ics/attacker/card_bg_5.png';
import {useParams} from "react-router-dom";
// import {useUpdateComponentState} from "../../../hooks";
import {useStore} from "../../../../store";

const ATTACKER_CARD_BACKGROUNDS = [
  CardBg1,
  CardBg2,
  CardBg3,
  CardBg4,
  CardBg5,
];

interface ISection1Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  const { updateParagraphState } = useStore();
  // const updateComponentState = useUpdateComponentState();
  React.useEffect(() => {
    updateParagraphState(p_course, p_topic, ID, 'completed', []);
  }, []);
  const attackerTargetItems = useMemo(
    () =>
      paragraphsSettings?.l2Lists?.map((item: { text?: string }, index: number) => ({
        ...item,
        backgroundImage:
          ATTACKER_CARD_BACKGROUNDS[index % ATTACKER_CARD_BACKGROUNDS.length],
      })),
    [paragraphsSettings?.l2Lists]
  );
  // const onWhyComplete = React.useCallback(() => {
  //   updateComponentState(
  //     p_course,
  //     p_topic,
  //     ID,
  //     'sme-ics-section2-1'
  //   );
  // }, [updateComponentState, p_course, p_topic, ID]);
  return (
    <div className="topic-section-2">
      <WhySmeTargetContent
        title={paragraphsSettings?.title}
        description={paragraphsSettings?.l2}
        items={paragraphsSettings?.tetralogyList}
        backgroundImage={TargetBg}
      />
      <AttackerTargetGrid
        title={paragraphsSettings?.tips}
        description={paragraphsSettings?.l2Text1}
        items={attackerTargetItems}
      />
    </div>
  );
};

export default Section2;
